import { TokenPrice } from "@typings/tokenPrice"

export const getTokenPrices = async (
  authToken: string
): Promise<TokenPrice[]> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_CORE_API_URL}/tokens/prices`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )

    if (!response.ok)
      throw new Error(`Error: ${response.status} ${response.statusText}`)

    const data = await response.json()

    const tokens: TokenPrice[] = data.data
    return tokens
  } catch (error) {
    console.error("Failed to fetch tokens:", error)
    throw error
  }
}
